export default "__VITE_ASSET__BRmMOVY$__"